var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.$isFlag
        ? "registerH5 accountCommonH5"
        : "registerWeb accountCommonWeb"
    },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "title-mb": _vm.titleArray[0],
          "type-next": "click"
        },
        on: { navBarClick: _vm.navBarClick }
      }),
      _c("div", { staticClass: "formClass" }, [
        _c(
          "div",
          [
            _c(
              "van-form",
              { staticClass: "findTwo", on: { submit: _vm.onSubmitReg } },
              [
                _c("van-field", {
                  staticStyle: { "border-radius": "16px" },
                  attrs: {
                    label: "注册手机号：",
                    rules: _vm.rules.mobileRules
                  },
                  model: {
                    value: _vm.formParams.username,
                    callback: function($$v) {
                      _vm.$set(_vm.formParams, "username", $$v)
                    },
                    expression: "formParams.username"
                  }
                }),
                _c("p", { staticClass: "reg_p" }, [
                  _vm._v(
                    " *该手机号为雷霆账号，雷霆账号一旦注册成功就无法变更。 "
                  )
                ]),
                _c("van-field", {
                  staticStyle: { "border-radius": "16px" },
                  attrs: {
                    maxlength: "6",
                    label: "短信验证码：",
                    rules: _vm.rules.codeRules
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "button",
                      fn: function() {
                        return [
                          !_vm.showTime
                            ? _c(
                                "p",
                                {
                                  staticStyle: {
                                    color: "#616edf",
                                    cursor: "pointer"
                                  },
                                  on: { click: _vm.getCode }
                                },
                                [_vm._v(" " + _vm._s(_vm.timeMsg) + " ")]
                              )
                            : _c(
                                "p",
                                {
                                  staticStyle: {
                                    color: "#878787",
                                    cursor: "pointer"
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.codeTime) + " S ")]
                              )
                        ]
                      },
                      proxy: true
                    }
                  ]),
                  model: {
                    value: _vm.formParams.code,
                    callback: function($$v) {
                      _vm.$set(_vm.formParams, "code", $$v)
                    },
                    expression: "formParams.code"
                  }
                }),
                _c("p", { staticClass: "reg_p" }, [
                  _vm._v("*如果一分钟内没有收到验证码请重新获取")
                ]),
                _c("van-field", {
                  staticStyle: { "border-radius": "16px 16px 0 0" },
                  attrs: {
                    label: "新密码：",
                    type: "password",
                    rules: _vm.rules.passwordRules
                  },
                  model: {
                    value: _vm.formParams.password,
                    callback: function($$v) {
                      _vm.$set(_vm.formParams, "password", $$v)
                    },
                    expression: "formParams.password"
                  }
                }),
                _c("van-field", {
                  attrs: {
                    label: "确认新密码：",
                    type: "password",
                    rules: _vm.rules.passwordRules
                  },
                  model: {
                    value: _vm.formParams.secondPassword,
                    callback: function($$v) {
                      _vm.$set(_vm.formParams, "secondPassword", $$v)
                    },
                    expression: "formParams.secondPassword"
                  }
                }),
                _c("van-field", {
                  attrs: { label: "真实姓名：", rules: _vm.rules.nameRules },
                  model: {
                    value: _vm.formParams.realName,
                    callback: function($$v) {
                      _vm.$set(_vm.formParams, "realName", $$v)
                    },
                    expression: "formParams.realName"
                  }
                }),
                _c("van-field", {
                  staticStyle: { "border-radius": "0 0 16px 16px" },
                  attrs: { label: "身份证号：", rules: _vm.rules.idRules },
                  model: {
                    value: _vm.formParams.idCard,
                    callback: function($$v) {
                      _vm.$set(_vm.formParams, "idCard", $$v)
                    },
                    expression: "formParams.idCard"
                  }
                }),
                _c("p", { staticClass: "reg_p--red" }, [
                  _vm._v("*未满18周岁的用户不允许注册雷霆账号")
                ]),
                _c(
                  "div",
                  { staticClass: "bottom" },
                  [
                    _c(
                      "van-checkbox",
                      {
                        staticClass: "checkbox",
                        model: {
                          value: _vm.checked,
                          callback: function($$v) {
                            _vm.checked = $$v
                          },
                          expression: "checked"
                        }
                      },
                      [
                        _vm._v("我已阅读并同意 "),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "#626fdd" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.ltPassRule($event)
                              }
                            }
                          },
                          [_vm._v("《雷霆游戏用户协议》")]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "#626fdd" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.ltUserRule($event)
                              }
                            }
                          },
                          [_vm._v("《雷霆游戏用户隐私政策》")]
                        )
                      ]
                    ),
                    _c(
                      "van-button",
                      {
                        staticClass: "formClass_btn",
                        attrs: {
                          round: "",
                          block: "",
                          type: "info",
                          "native-type": "submit",
                          color: "#616edf"
                        }
                      },
                      [_vm._v("注册")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }